import { type SxProps } from '@mui/system'
import React, { type ReactElement } from 'react'
import { Typography, useTheme } from '@mui/material'

import styles from '../tooltipCellWrapper/CellInfoWrapper.module.scss'

interface CellWrapperProps {
  title: string
  value?: string | React.ReactNode
  valueSx?: SxProps
  style?: React.CSSProperties
  width?: string
  className?: string
}

const CellWrapper: React.FC<CellWrapperProps> = ({
  title,
  value,
  style,
  valueSx,
  width,
  className,
  ...rest
}): ReactElement => {
  const { palette } = useTheme()

  return (
    <div className={`${styles.cellInfoWrapper} ${className ?? ''}`} style={{ width }} {...rest}>
      <div className={styles.info}>
        <Typography variant="subtitle1" sx={{ color: palette.gray.main }}>
          {title}
        </Typography>
        <Typography variant="title3" sx={valueSx} className={styles.value} style={style}>
          {value}
        </Typography>
      </div>
    </div>
  )
}

export default CellWrapper
